import React from "react";
import { Box } from "@material-ui/core";
import Loader from "@/components/shared/loader";
export default function Redirection() {
	return (
		<Box height="100vh" width="100vw">
			<Loader />
		</Box>
	);
}
